<template>
    <div>
        <div class="content">
            <el-form class="form" label-position="left" label-width="100px" size="small"
                     style="text-align: left;padding: 20px 32px 0 32px;">
                <el-form-item label="项目状态" class="checkbox-title">
                    <el-checkbox v-model="stateAll" class="checkbox-all" @change="handleCheckAll('StateList','stateAll',$event)">不限</el-checkbox>
                    <el-checkbox-group v-model="checkStateList" class="checkbox-content" @change="handleCheck('StateList','stateAll')">
                        <el-checkbox v-for="(item, index) in stateList" :key="index" style="width: 86px" :label="item.value">
							{{item.text}}
						</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="项目分类" class="checkbox-title">
                    <el-checkbox v-model="categoryAll" class="checkbox-all" @change="handleCheckAll('CategoryList','categoryAll',$event)">不限</el-checkbox>
                    <el-checkbox-group v-model="checkCategoryList" class="checkbox-content" @change="handleCheck('CategoryList','categoryAll')">
                        <el-checkbox v-for="(category, index) in categories" :label="category.value" :key="index" style="width: 90px" :style="{'margin-left': index%8==0||index==0?'0px':'30px'}">
                            {{category.text}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="所在组" class="checkbox-title">
                    <el-checkbox v-model="directionAll" class="checkbox-all" @change="handleCheckAll('DirectionList','directionAll',$event)">不限</el-checkbox>
                    <el-checkbox-group v-model="checkDirectionList" class="checkbox-content" @change="handleCheck('DirectionList','directionAll')">
                        <el-checkbox v-for="(direction, index) in researchDirections" :label="direction.value" :key="index" style="width: 90px" :style="{'margin-left': index%8==0||index==0?'0px':'30px'}">
                            {{direction.text}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="上传地点" class="checkbox-title">
                    <el-checkbox v-model="regionAll" class="checkbox-all" @change="handleCheckAll('RegionList','regionAll',$event)">不限</el-checkbox>
                    <el-checkbox-group v-model="checkRegionList" class="checkbox-content" @change="handleCheck('RegionList','regionAll')">
                        <el-checkbox v-for="(city, index) in cityList" :key="index" style="width: 86px" :label="city.value">
							{{city.text}}
						</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
        </div>
        <div class="content">
            <div style="display:flex;justify-content: center;">
                <el-input type="hidden" placeholder="请输入内容" v-model="innerQueryString" class="input-with-select"
                          @keyup.enter.native="keyenter">
                </el-input>
            </div>
            <!--       <div class="message-area-top" z-index="9999">
                    <el-tabs v-model="activeName" class="tabs">
                      <el-tab-pane label="项目" name="1" style="margin-left:40px"></el-tab-pane>
                      <el-tab-pane label="数据" name="2"></el-tab-pane>
                    </el-tabs>
                  </div> -->
<!--            <div style="width:auto;height:2px;margin-top:12px;background-color:#D5D5D5;overflow:hidden;"></div>-->
            <div v-show="activeName==1" class="card-list" style="padding-bottom:100px;margin-top: 30px">
                <div v-show="shownodeData" style="margin-top:100px;">未搜索到匹配的项目</div>
                <div v-show="projects.length>0">
                    <div v-for="(items,index) in projects" :key="index" style="display:flex;width:100%;"
                         :style="{'margin-top':index==0?'0px':'32px'}">
                        <pms-project-card :source="'search'" v-if="projectCardType==0" v-for="(item,sindex) in items"
                                          :key="item.id" :style="{'margin-left':sindex==0?'0px':'66px'}" :item="item"
                                          @editProject="editProject" @projectDetail="projectDetail"></pms-project-card>
                        <!-- <ds-project-card v-for="(item,sindex) in items" :key="sindex" :style="{'margin-left':sindex==0?'0px':'50px'}" :item="item" @editProject="editProject" @projectDetail="projectDetail"></ds-project-card> -->
                    </div>
                    <div class="pagination">
                        <el-pagination style="float:right" small background @current-change="pageIndexChange"
                                       layout="prev, pager, next" :total="totalProjects" :page-size="per_page"
                                       v-show="totalProjects>1">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <div v-show="activeName==2">
                <div style="margin-top: 100px;"></div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .content {
        margin-top: 15px;
        width: 1200px;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
        background-color: #ffffff;
        border-bottom: 15px #f0f2f5 solid;
    }

    .card-list {
        // background-color: #716f6f;
        margin-top: 17px;
        height: auto;
        margin-left: 32px;
        margin-right: 32px;

        .pagination {
            background-color: #ffffff;
            width: 100%;
            margin-top: 53px;
        }
    }

    .search_button {
        margin-top: -1px;
        position: absolute;
        margin-left: 473px;
        width: 73px;
        height: 42px;
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
        display: flex;
        justify-content: center;
        background-color: #1890ff;
        color: #ffffff;
    }

    .el-dialog__footer {
        text-align: center;
    }

    .message-area-top {
        height: 50px;
        margin-top: 20px;

        .tabs {
            margin-left: 80px;
            height: 24px;
        }
    }

    .checkbox-title {
        font-size: 16px;
        font-weight: bold;
    }

    .checkbox-content {
        display: inline-block;
        font-size: 14px;
        width: 90%;
        vertical-align: top;
    }

    .checkbox-all {
        display: inline-block;
        margin-right: 30px;
    }
</style>
<script>
import PMSProjectCard from "@/js/modules/project/ui/etl_project/project_list/PMSProjectCard";
import Constants from "@/js/utils/constants";
import config from "@/js/utils/config";
import {MessageBox} from "element-ui";

let Base64 = require("js-base64").Base64;
export default {
    name: "SearchProject",
    components: {
        "pms-project-card": PMSProjectCard
    },
    data() {
        return {
            categories: [],             //项目分类
            researchDirections: [],     //所在组
			stateList:[], //状态分类
			cityList:[], //地点分类
            checkStateList: [],
            checkCategoryList: [],
            checkDirectionList: [],
            checkRegionList: [],
            stateAll: true,
            categoryAll: true,
            directionAll: true,
            regionAll: true,
            activeName: "1",
            shownodeData: false,
            outerQueryString: "",
            innerQueryString: "",
            createProjectType: "",
            pageIndex: 1,
            per_page: 15,
            projects: [],
            totalProjects: 0,
            projectCardType: 0 //0-项目经理 1-需求方
        };
    },

    mounted() {

        //上报页面数据
        let body = {event_code: "queen_all_ssjgy", event_name: "搜索结果页"};
        this.CommonSrv.trackEvent(body);
        this.initCategories();
    },

    created() {
        //加载网络请求数据
        if (!this.outerQueryString) {
            this.outerQueryString = this.decodeQuery(this.$route.query.query);
            this.innerQueryString = this.outerQueryString;
            this.keyenter();
            this.getProjects();
            // decodeURI(this.$route.query.query);
        }
    },
    //当在topbar输入框搜索的时候调用router的replace方法执行下面方法
    beforeRouteUpdate(to, from, next) {
        // 在当前路由改变，但是该组件被复用时调用
        // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
        // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
        // 可以访问组件实例 `this`
        this.outerQueryString = this.decodeQuery(to.query.query);
        this.innerQueryString = this.outerQueryString;
        this.getProjects();
        // decodeURI(decodeURI(to.query.query));
        next();
    },

    methods: {
        decodeQuery(query) {
            let newquery = decodeURI(query);
            let flag = newquery.indexOf("%") >= 0;
            while (flag) {
                newquery = decodeURI(newquery);
                flag = newquery.indexOf("%") >= 0;
            }
            return newquery;
        },
        keyenter() {
            this.$router.replace({
                path: "/searchProject",
                query: {query: this.innerQueryString}
            });
        },
        closeDialog() {
            this.createProjectType = "";
            this.queryprojectID = "";
            this.queryProjectIds = [];
        },

        editProject(projectId) {
            this.$router.push({
                path: "/create-project",
                query: {id: projectId, operationType: 2}
            });
        },

        projectDetail(projectId, edit, jobUid) {
            this.$router.push({
                path: "/project-detail",
                query: {id: projectId, edit: edit, uid: jobUid, frompage: "searchpage"}
            });
        },

        getProjects() {
            if (!this.innerQueryString) {
                MessageBox.alert("请输入搜索内容", "提示信息", {
                    type: "warning",
                    showConfirmButton: false,
                    center: true
                });
                return;
            }
            var that = this;
            let url = config.api.filter_jobs;
            var operation = 1;
            let userinfo = JSON.parse(localStorage.getItem("userinfo"));
            if (!userinfo) {
                return;
            }
            if (userinfo.role != Constants.USER_ROLE.PM) {
                operation = 0;
            }
            let params = {
            	entities:'process',
                page: this.pageIndex,
                per_page: this.per_page,
                job_uid: this.innerQueryString,
                title: this.innerQueryString,
                operation: operation,
				sorts: 'modified_at|desc',
                over: 0,
                ride: 0,
				from_process: 1,
				states: this.checkStateList.join(","),
				category_ids: this.checkCategoryList.join(","),
				direction_ids: this.checkDirectionList.join(","),
				regions: this.checkRegionList.join(","),
            };
            this.HttpUtils.get(url, params)
                .then(result => {
                    that.projects = that.groupProjects(result.data.items);
                    if (that.projects.length) {
                        this.shownodeData = false;
                    } else {
                        this.shownodeData = true;
                    }
                    that.totalProjects = result.data.pagination.total;
                })
                .catch(execption => {
                    console.log(execption);
                });
        },

        groupProjects(items) {
            var num = 3; //每个子数组里的元素个数
            var tmpprojects = new Array(Math.ceil(items.length / num));
            for (var i = 0; i < tmpprojects.length; i++) {
                tmpprojects[i] = new Array();
                for (var j = 0; j < num; j++) {
                    if (i * num + j < items.length) {
                        tmpprojects[i][j] = items[i * num + j];
                    }
                }
            }
            return tmpprojects;
        },

        pageIndexChange(val) {
            this.pageIndex = val;
            this.getProjects();
        },

        initCategories() {
			this.HttpUtils.get(config.api.filter_select, {keys:'job_state,category,direction,region'})
				.then(result => {
					result.data.items.forEach(item => {
						switch (item.key) {
							case 'states': this.stateList = item.options;break
							case 'category_ids': this.categories = item.options;break
							case 'direction_ids': this.researchDirections = item.options;break
							case 'regions': this.cityList = item.options;break
						}
					})
				})
				.catch(execption => {
				});
        },

        handleCheckAll(name, allName, val) {
            this["check" + name] = val ? [] : this.checkStateList;
            this[allName] = this.checkStateList.length < 1;
            this.pageIndex = 1;
            this.getProjects();
        },
        handleCheck(name, allName) {
            this[allName] = this["check" + name].length<1;
            this.pageIndex = 1;
            this.getProjects();
        },
    }
};
</script>




// WEBPACK FOOTER //
// src/js/modules/search/searchProject.vue